import useUserQueryStore from "../context/UserStore";
import APIClient from "../services/apiClient";
import MultiTenantConfigGetDto from "../dtos/multiTenantConfigDto";
import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import { normalizeConfig } from "../utils/ConfigNormalization";

const useConfigs = () => {
  const currentToken = useUserQueryStore((s) => s.userQuery.currentToken);
  const apiClient = new APIClient<MultiTenantConfigGetDto>("/MultiTenantConfig", currentToken!);

  return useQuery({
    queryKey: ["configurations"],
    queryFn: async () => {
      const response = await apiClient.getAll();
      const documents = Array.isArray(response) ? response : [];
      return documents.map(normalizeConfig);
    },
    staleTime: ms("1m"),
  });
};

export default useConfigs;
